var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg555(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "555 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect82",
    d: "M91.1534 26.8245H30.2915V87.6865H91.1534V26.8245Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect84",
    d: "M185.677 26.8257H124.815V87.6888H185.677V26.8257Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect86",
    d: "M91.1534 123.124H30.2915V183.985H91.1534V123.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect88",
    d: "M185.677 123.125H124.815V183.987H185.677V123.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect90",
    d: "M280.506 27.1153H219.645V87.9772H280.506V27.1153Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect92",
    d: "M375.031 27.1164H314.168V87.9784H375.031V27.1164Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect94",
    d: "M280.506 123.415H219.645V184.275H280.506V123.415Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect96",
    d: "M375.031 123.416H314.168V184.278H375.031V123.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect98",
    d: "M91.1534 219.713H30.2915V280.577H91.1534V219.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect100",
    d: "M185.677 219.713H124.815V280.577H185.677V219.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect102",
    d: "M91.1534 316.011H30.2915V376.874H91.1534V316.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect104",
    d: "M185.677 316.013H124.815V376.874H185.677V316.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect106",
    d: "M280.506 219.713H219.645V280.575H280.506V219.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect108",
    d: "M375.031 219.713H314.168V280.577H375.031V219.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect110",
    d: "M280.506 316.011H219.645V376.874H280.506V316.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect112",
    d: "M375.031 316.013H314.168V376.874H375.031V316.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect114",
    d: "M469.554 27.1164H408.691V87.9784H469.554V27.1164Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect116",
    d: "M469.554 123.416H408.691V184.278H469.554V123.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect118",
    d: "M469.554 219.713H408.691V280.577H469.554V219.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect120",
    d: "M469.554 316.013H408.691V376.874H469.554V316.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect122",
    d: "M91.3063 412.312H30.4444V473.175H91.3063V412.312Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect124",
    d: "M185.83 412.315H124.968V473.175H185.83V412.315Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect126",
    d: "M280.66 412.312H219.798V473.175H280.66V412.312Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect128",
    d: "M375.185 412.315H314.32V473.175H375.185V412.315Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect130",
    d: "M469.709 412.315H408.843V473.175H469.709V412.315Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg555);
export default __webpack_public_path__ + "static/media/555.1cd26583e88afe44cc6b9b2da3af6bf0.svg";
export { ForwardRef as ReactComponent };